(function () {
  if (window.__ecjPathsBound) return;
  window.__ecjPathsBound = true;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var behavior = reduce ? "auto" : "smooth";
  var navBtn = document.querySelector(".nav-toggle");
  var nav = document.getElementById("site-nav");
  if (navBtn && nav) {
    navBtn.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      navBtn.setAttribute("aria-expanded", open ? "true" : "false");
    });
    nav.addEventListener("click", function (event) {
      if (event.target.closest("a")) {
        nav.classList.remove("is-open");
        navBtn.setAttribute("aria-expanded", "false");
      }
    });
  }

  var slides = Array.prototype.slice.call(document.querySelectorAll("[data-slide]"));
  var dots = Array.prototype.slice.call(document.querySelectorAll("[data-go]"));
  var heroIndex = 0;
  function showHero(n) {
    if (!slides.length) return;
    heroIndex = (n + slides.length) % slides.length;
    slides.forEach(function (slide, idx) {
      var on = idx === heroIndex;
      slide.classList.toggle("is-active", on);
      slide.setAttribute("aria-hidden", on ? "false" : "true");
    });
    dots.forEach(function (dot, idx) {
      dot.setAttribute("aria-current", idx === heroIndex ? "true" : "false");
    });
  }
  document.querySelectorAll("[data-hero]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      showHero(heroIndex + parseInt(btn.getAttribute("data-hero"), 10));
    });
  });
  dots.forEach(function (dot) {
    dot.addEventListener("click", function () {
      showHero(parseInt(dot.getAttribute("data-go"), 10));
    });
  });

  var reviewSource = document.getElementById("reviews-source");
  var reviewTrack = document.getElementById("review-track");
  var reviewEmpty = document.getElementById("review-empty");
  if (reviewSource && reviewTrack) {
    var reviews = [];
    try {
      reviews = JSON.parse(reviewSource.textContent).filter(function (item) {
        return item && String(item.text || "").trim();
      });
    } catch (error) {
      reviews = [];
    }
    if (!reviews.length) {
      if (reviewEmpty) reviewEmpty.hidden = false;
    } else {
      reviews.forEach(function (item) {
        var stars = Math.max(1, Math.min(5, parseInt(item.stars, 10) || 5));
        var card = document.createElement("blockquote");
        card.className = "review";
        var star = document.createElement("p");
        star.className = "stars";
        star.setAttribute("aria-label", stars + " out of 5");
        star.textContent = "★★★★★".slice(0, stars);
        var body = document.createElement("p");
        body.className = "review-text";
        body.textContent = item.text;
        var meta = document.createElement("p");
        meta.className = "review-meta";
        var who = document.createElement("cite");
        who.textContent = item.name || "Etsy buyer";
        meta.appendChild(who);
        if (item.date) meta.appendChild(document.createTextNode("  " + item.date));
        if (item.product) {
          var prod = document.createElement("span");
          prod.textContent = item.product;
          prod.style.display = "block";
          meta.appendChild(prod);
        }
        card.append(star, body, meta);
        reviewTrack.appendChild(card);
      });
    }
  }

  document.querySelectorAll("[data-rail]").forEach(function (rail) {
    var track = rail.querySelector(".rail-track");
    var controls = rail.parentElement.querySelector(".rail-nav") || rail.closest("section, article").querySelector(".rail-nav");
    if (!controls || !track) return;
    controls.querySelectorAll("[data-dir]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var card = track.querySelector(".card, .post, .review");
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
        var width = card ? card.getBoundingClientRect().width + gap : 280;
        var dir = parseInt(btn.getAttribute("data-dir"), 10);
        var max = track.scrollWidth - track.clientWidth;
        if (dir > 0 && track.scrollLeft >= max - 4) track.scrollTo({ left: 0, behavior: behavior });
        else if (dir < 0 && track.scrollLeft <= 4) track.scrollTo({ left: max, behavior: behavior });
        else track.scrollBy({ left: dir * width, behavior: behavior });
      });
    });
  });

  var sort = document.getElementById("sort");
  if (sort) {
    sort.addEventListener("change", function () {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", sort.value);
      url.searchParams.delete("page");
      window.location.assign(url.toString());
    });
  }

  var grid = document.getElementById("grid");
  if (grid) {
    var cards = Array.prototype.slice.call(grid.querySelectorAll(".pcard"));
    var empty = document.getElementById("empty");
    var count = document.getElementById("count");
    var filter = "all";
    function applyFilter() {
      var shown = cards.filter(function (card) {
        return filter === "all" || card.getAttribute("data-stone") === filter;
      });
      cards.forEach(function (card) {
        card.classList.toggle("is-hidden", shown.indexOf(card) === -1);
      });
      if (count) count.textContent = shown.length + (shown.length === 1 ? " piece" : " pieces");
      if (empty) empty.style.display = shown.length ? "none" : "block";
    }
    document.querySelectorAll(".chip[data-filter]").forEach(function (chip) {
      chip.addEventListener("click", function () {
        filter = chip.getAttribute("data-filter");
        document.querySelectorAll(".chip[data-filter]").forEach(function (el) {
          el.setAttribute("aria-pressed", el === chip ? "true" : "false");
        });
        applyFilter();
      });
    });
  }

  var sceneBtns = Array.prototype.slice.call(document.querySelectorAll(".moment"));
  var sceneLines = Array.prototype.slice.call(document.querySelectorAll(".scene-line"));
  var sceneFrame = document.getElementById("scene-frame");
  if (sceneFrame && sceneBtns.length) {
    var sceneIndex = 0;
    function showScene(n) {
      var next = (n + sceneBtns.length) % sceneBtns.length;
      if (next === sceneIndex) return;
      sceneIndex = next;
      sceneBtns.forEach(function (btn, i) {
        btn.setAttribute("aria-selected", i === sceneIndex ? "true" : "false");
      });
      sceneLines.forEach(function (line, i) {
        var on = i === sceneIndex;
        line.classList.toggle("is-on", on);
        line.hidden = !on;
      });
      var current = document.getElementById("scene-photo");
      var btn = sceneBtns[sceneIndex];
      if (reduce) {
        current.src = btn.getAttribute("data-src");
        current.alt = btn.getAttribute("data-alt");
        return;
      }
      var incoming = document.createElement("img");
      incoming.src = btn.getAttribute("data-src");
      incoming.alt = btn.getAttribute("data-alt");
      incoming.style.opacity = "0";
      incoming.style.transform = "scale(1.04)";
      sceneFrame.appendChild(incoming);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          incoming.style.opacity = "1";
          incoming.style.transform = "scale(1)";
          current.style.opacity = "0";
        });
      });
      var finished = false;
      function done() {
        if (finished) return;
        finished = true;
        if (current.parentNode) current.parentNode.removeChild(current);
        incoming.id = "scene-photo";
        incoming.style.opacity = "";
        incoming.style.transform = "";
      }
      incoming.addEventListener("transitionend", done);
      setTimeout(done, 1000);
    }
    sceneBtns.forEach(function (btn, i) {
      btn.addEventListener("click", function () { showScene(i); });
    });
    var swipeX = null;
    sceneFrame.addEventListener("pointerdown", function (event) { swipeX = event.clientX; });
    sceneFrame.addEventListener("pointerup", function (event) {
      if (swipeX == null) return;
      var dx = event.clientX - swipeX;
      swipeX = null;
      if (Math.abs(dx) > 40) showScene(sceneIndex + (dx < 0 ? 1 : -1));
    });
  }
})();
